import styled from 'styled-components';

/** Area ristretta con contenuto centrato (max 600px) */
export const ContentAreaNarrow = styled.div`
  max-width: 600px;
  margin: 0 auto;
`;
/** Area con un padding superiore ed inferiore di 24px */
export const ContentArea = styled.div`
  padding: 24px 0;
`;
